import React, { useState, useEffect } from 'react';
import { Field } from 'formik';
import { useSelector } from 'react-redux';
import { temPerfilRBAC } from '../../../secutity/acl';
import { PERFIL } from '../../../common/Constants';
import axios from 'axios';
import { getHeaders } from '../../../request';
import { UF, MUNICIPIO } from '../fieldNames';
import { SttAutocomplete } from '@stt-componentes/core';

const Uf = ( props ) => {
	const { strings } = props;

    const { filtros, listar } = useSelector(state => state.exame);
    const user = useSelector(state => state.index.user);

    const [ufs, setUfs] = useState([]);
    const [municipios, setMunicipios] = useState([]);
    const [filtroPorLocal, setFiltroPorLocal] = useState(false);
    const [filtroPorRede, setFiltroPorRede] = useState(false);
    const [filtroPorFuncionario, setFiltroPorFuncionario] = useState(false);
    const [carregarUfs, setCarregarUfs] = useState(false);

    const UTILITARIOS_API_BASE_URL = global.gConfig.url_base_utilitarios;

    useEffect(() => {
        if (temPerfilRBAC(user, PERFIL.ADMINISTRADOR) || temPerfilRBAC(user, PERFIL.ADMINISTRADOR_ESTADUAL)) {
            setCarregarUfs(true);
            setFiltroPorLocal(true);
            setFiltroPorRede(true);
            setFiltroPorFuncionario(true);
        }
        if (temPerfilRBAC(user, PERFIL.MEDICO_SOLICITANTE)) {
            setCarregarUfs(true);
            setFiltroPorLocal(true);
        }
        if (temPerfilRBAC(user, PERFIL.VISUALIZADOR_REDE)) {
            setCarregarUfs(true);
            setFiltroPorLocal(true);
        }
    }, []);

    useEffect(() => {
        if (carregarUfs) {
            let url = `${UTILITARIOS_API_BASE_URL}/localizacao/estado`;
            if (temPerfilRBAC(user, PERFIL.ADMINISTRADOR_ESTADUAL)) {
                const perfil = user.perfisRBAC.filter(p => p.identificador === PERFIL.ADMINISTRADOR_ESTADUAL);
                const estados = perfil[0].estados;
                const idsUf = estados.map(e => e.id);
                url = `${url}?ids=${idsUf.join(',')}`;
            }

            axios
                .get(url, { headers: getHeaders() })
                .then((response) => {
                    if (response.data) {
                        const { itens } = response.data.data;
                        setUfs(itens);
                    }
                })
                .catch(err => console.log(err));
        }
    }, [carregarUfs])

    const handleChangeUf = (uf) => {
        if (filtroPorLocal && uf) {
            axios
                .get(`${UTILITARIOS_API_BASE_URL}/localizacao/cidade?id-estado=${uf.id}`, { headers: getHeaders() })
                .then((response) => {
                    if (response.data) {
                        const { itens } = response.data.data;
                        setMunicipios(itens);
                    } else {
                        setMunicipios([]);
                    }
                })
                .catch(err => console.log(err));
        }
    }

    return (
        <Field name={UF}>
            {({
                field: { name, value, onBlur },
                form: { setFieldValue }
            }) => (
                <SttAutocomplete
                    inputprops={{
                        name: name,
                        label: strings.uf
                    }}
                    getOptionLabel={option => option && option.sigla || ''}
                    getOptionSelected={(option, val) => option && val && option.id === val.id}
                    options={ufs}
                    value={value}
                    onBlur={onBlur}
                    onChange={(e, item) => {
                        setFieldValue(UF, item || null);
                        setFieldValue(MUNICIPIO, null);
                        handleChangeUf(item);
                    }}
                />
            )}
        </Field>
    );
};

export default Uf